import React, { Component, Fragment } from 'react'
import { Typography, CircularProgress } from '@material-ui/core'
import InsuranceApplication from '../model/insurance-application';
import axios from 'axios'
import Crop from '../model/crop';
import ApplicationValue from '../model/application-value';

interface ICompletedProps {
    data: InsuranceApplication;
    prevClick: any;
    renderButtons: any;
}

export class CompletedForm extends Component<ICompletedProps, any> {

    constructor(props: ICompletedProps) {
        super(props);
        this.state = {
            form: this.props.data,
            sent: false,
            sending: false,
            error: false,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    finish = () => {
        window.location.href = "https://sagabrokers.pl/ubezpieczenie-upraw/";
    }

    getData = () => {
        var data: any = {};
        var ia = this.state.form;

        data.applicationValues = ia.applicationValues.map((av: ApplicationValue) => {
            return {
                key: av.key,
                selectedIndex: av.selectedIndex,
                value: av.value
            }
        });

        data.insurer = {};
        if (ia.insurer.type == 1) {
            data.insurer.firstName = ia.insurer.firstName;
            data.insurer.lastName = ia.insurer.lastName;
            data.insurer.PESEL = ia.insurer.PESEL;
        }
        if (ia.insurer.type == 2) {
            data.insurer.companyName = ia.insurer.companyName;
            data.insurer.REGON = ia.insurer.REGON;
        }
        data.insurer.email = ia.insurer.email;
        data.insurer.phoneNumber = ia.insurer.phoneNumber;

        data.insurer.address = {};
        data.insurer.address.cityName = ia.insurer.address.cityName;
        data.insurer.address.streetName = ia.insurer.address.streetName;
        data.insurer.address.streetNumber = ia.insurer.address.streetNumber;
        data.insurer.address.apartmentNumber = ia.insurer.address.apartmentNumber;
        data.insurer.address.postalCode = ia.insurer.address.postalCode;

        if (!ia.insurer.postalAddressSameAsAddress) {
            data.insurer.postalAddress = {};
            data.insurer.postalAddress.addressee = ia.insurer.postalAddress.addressee;
            data.insurer.postalAddress.cityName = ia.insurer.postalAddress.cityName;
            data.insurer.postalAddress.streetName = ia.insurer.postalAddress.streetName;
            data.insurer.postalAddress.streetNumber = ia.insurer.postalAddress.streetNumber;
            data.insurer.postalAddress.apartmentNumber = ia.insurer.postalAddress.apartmentNumber;
            data.insurer.postalAddress.postalCode = ia.insurer.postalAddress.postalCode;
        }


        data.insured = {};
        let insured = ia.insured;
        if (insured.insuredSameAsInsurer)
            insured = ia.insurer;

        if (insured.type == 1) {
            data.insured.firstName = insured.firstName;
            data.insured.lastName = insured.lastName;
            data.insured.PESEL = insured.PESEL;
        }
        if (insured.type == 2) {
            data.insured.companyName = insured.companyName;
            data.insured.REGON = insured.REGON;
        }

        data.insured.address = {};
        data.insured.address.cityName = insured.address.cityName;
        data.insured.address.streetName = insured.address.streetName;
        data.insured.address.streetNumber = insured.address.streetNumber;
        data.insured.address.apartmentNumber = insured.address.apartmentNumber;
        data.insured.address.postalCode = insured.address.postalCode;


        data.crops = [];
        for (let i = 0; i < ia.crops.length; i++) {
            let cr: Crop = ia.crops[i];

            let crop: any = {};
            crop.cropName = cr.cropName;
            crop.cropType = cr.cropType;
            crop.voivodeship = cr.voivodeship;
            crop.district = cr.district;
            crop.commune = cr.commune;
            crop.precinct = cr.precinct;
            crop.parcelNumber = cr.parcelNumber;
            crop.occurrence = cr.occurrence;
            crop.soilClass = cr.soilClass;
            crop.soilCategory = cr.soilCategory;
            crop.area = cr.area;
            crop.estimatedEfficiency = cr.estimatedEfficiency;
            crop.estimatedPrice = cr.estimatedPrice;
            crop.casting = cr.casting;
            crop.leafAmount = cr.leafAmount

            data.crops.push(crop);

            let cropsAv: ApplicationValue[] = [];
            cr.insuranceCoverage.forEach((ic: ApplicationValue) => {
                cropsAv.push(new ApplicationValue(ic.key + '-' + i, ic.value, ic.selectedIndex));
            })

            data.applicationValues.push(...cropsAv);
        }

        return data;
    }

    send = () => {
        this.setState({ sending: true });

        let data = this.getData();
        const options = {
            headers: {
                'Access-Control-Allow-Origin': '*'
            }
        }

        axios.post(`https://online.sagabrokers.pl/agro/application/create`, data, options)
            .then(res => {
                this.setState({ sending: false, sent: true, error: false });
            }).catch((error) => {
                this.setState({ sending: false, sent: true, error: true });
            });
    }

    beforeSend() {
        return (
            <>
                <Typography variant="h5" align="center" paragraph={true} gutterBottom>Dziękujemy za wypełnienie wniosku.</Typography>
                <Typography variant="body1" align="center">Wciśnij wyślij, aby wniosek trafił do nas.</Typography>
                {this.props.renderButtons({ caption: 'Wyślij', click: this.send }, { caption: 'Wstecz', click: this.props.prevClick }, undefined, undefined)}
            </>
        )
    }

    sendSuccess() {
        return (
            <Fragment>
                <Typography variant="h5" align="center" paragraph={true} gutterBottom>Dziękujemy za złożenie wniosku o zawarcie ubezpieczenia upraw rolnych.</Typography>

                <Typography variant="body1" align="center">Na podstawie danych zawartych we wniosku przygotujemy dla Ciebie najkorzystniejszą ofertę ubezpieczenia.</Typography>
                <Typography variant="body1" align="center">Ofertę prześlemy na Twój adres e-mail.</Typography>

                {this.props.renderButtons(undefined, undefined, undefined, { caption: 'Zakończ', click: this.finish })}
            </Fragment>
        )
    }

    sendError() {
        return (
            <Fragment>
                <Typography variant="h5" align="center" paragraph={true} gutterBottom>Błąd wysyłania wniosku.</Typography>

                <Typography variant="body1" align="center">Przepraszamy, ale wystąpił błąd wysyłania wniosku.</Typography>
                <Typography variant="body1" align="center">Wciśnij Wyślij, aby ponowić wysyłanie wniosku.</Typography>

                {this.props.renderButtons({ caption: 'Wyślij', click: this.send }, { caption: 'Wstecz', click: this.props.prevClick }, undefined, undefined)}
            </Fragment>
        )
    }

    sending() {
        return (
            <>
                <Typography variant="h5" align="center" paragraph={true} gutterBottom>Trwa wysyłanie wniosku...</Typography>
                <Typography variant="h5" align="center"><CircularProgress size={68} /></Typography>
            </>
        )
    }

    render() {
        if (!this.state.sent && !this.state.sending && !this.state.error)
            return this.beforeSend();
        else if (this.state.sending)
            return this.sending();
        else if (this.state.sent && !this.state.error)
            return this.sendSuccess();
        else if (this.state.sent && this.state.error)
            return this.sendError();

        return null;
    }

}
